(function ($, Drupal) {

  "use strict";

  Drupal.behaviors.dataGlobalAllocation = {
    attach: function (context,) {
      const $data = $('.data--global-allocation', context);
      const $window = $(window);

      // Animate the progress bars when scrolling.
      animateData();
      $window.scroll(function () {
        animateData();
      });

      function animateData() {
        $data.each(function () {
          const $this = $(this);
          if (isElementInViewport(this)) {
            $this.addClass('is-active');
          }
        });
      }
    }
  };

  function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document. documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document. documentElement.clientWidth)
    );
  }

})(jQuery, Drupal);
